import { desglosarVenta, rebajaDeLinea } from './descuentos';
import type { DescuentoDeVenta, LineaMostrador, TotalesVenta } from './tipos';

/** Unidades de un producto en una venta: el mismo tope que valida `registrar_venta`. */
export const CANTIDAD_MAXIMA = 9999;

/**
 * Agrupa líneas repetidas por SKU sumando cantidades (cada escaneo = +1; repetir no crea líneas nuevas).
 * Mantiene el orden de primera aparición.
 */
export function agruparLineas(lineas: LineaMostrador[]): LineaMostrador[] {
  const porSku = new Map<string, LineaMostrador>();
  for (const linea of lineas) {
    const existente = porSku.get(linea.sku);
    if (existente) {
      existente.cantidad += linea.cantidad;
    } else {
      porSku.set(linea.sku, { ...linea });
    }
  }
  return [...porSku.values()];
}

/**
 * Totales en COP enteros, igual que `registrar_venta`: descuentos primero, cada impuesto sobre su base y
 * redondeado al peso por separado. Total = subtotal + impuesto, con su CHECK espejo en la base.
 */
export function calcularTotales(
  lineas: LineaMostrador[],
  descuento?: Pick<DescuentoDeVenta, 'tipo' | 'valor' | 'libre'> | null
): TotalesVenta {
  const { lineas: _, ...totales } = desglosarVenta(lineas, descuento);
  return totales;
}

export function totalLinea(l: LineaMostrador): number {
  return Math.round(l.cantidad * l.precioUnit);
}

/** Lo que vale la línea tras su rebaja propia, sin su parte del descuento a la venta. */
export function netoDeLinea(l: LineaMostrador): number {
  return totalLinea(l) - rebajaDeLinea(l);
}
